<dropdown dropdownClass="header-nav-item-select nav-profile" (click)="navProfile.toggle($event)">
    <div class="toggle-wrapper d-flex align-items-center">
        <!--<avatar [size]="35" src="assets/images/avatars/thumb-1.jpg"></avatar>-->
        <span data-slot="avatar" class="profile-first-letter relative flex size-8 shrink-0 overflow-hidden rounded-full h-8 w-8"><span data-slot="avatar-fallback" class="bg-muted flex size-full items-center justify-center rounded-full">{{username}}</span></span>
        <span class="mx-1">{{this.currentUser.username}}</span>
        <i class="feather icon-chevron-down"></i>
    </div>
    <dropdown-menu #navProfile alignment="right">
        <div class="nav-profile-header">
            <div class="d-flex align-items-center">
                <!--<avatar src="assets/images/avatars/thumb-1.jpg"></avatar>-->
                <div class="d-flex flex-column ms-1">
                    <span class="text-dark">{{this.currentUser.username}}</span>
                    <span class="font-size-sm">{{this.currentUser.email}}</span>
                </div>
            </div>
        </div>
        <a href="javascript:void(0)" class="dropdown-item" (click)="logoutUser()">
            <div class="d-flex align-items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-log-out mr-2 h-4 w-4"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" x2="9" y1="12" y2="12"></line></svg>
                <span>Log out</span>
            </div>
        </a>
    </dropdown-menu>
</dropdown>
